/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConfirmEmailChangeRouteImport } from './routes/confirm-email-change'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as InviteCodeRouteImport } from './routes/invite.$code'
import { Route as AuthenticatedSubscriptionRouteImport } from './routes/_authenticated/subscription'
import { Route as AuthenticatedSearchRouteImport } from './routes/_authenticated/search'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDevicesRouteImport } from './routes/_authenticated/devices'
import { Route as AuthenticatedWikiIndexRouteImport } from './routes/_authenticated/wiki/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSkillsIndexRouteImport } from './routes/_authenticated/skills/index'
import { Route as AuthenticatedRoutinesIndexRouteImport } from './routes/_authenticated/routines/index'
import { Route as AuthenticatedResourcesIndexRouteImport } from './routes/_authenticated/resources/index'
import { Route as AuthenticatedMoreIndexRouteImport } from './routes/_authenticated/more/index'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages/index'
import { Route as AuthenticatedFilesIndexRouteImport } from './routes/_authenticated/files/index'
import { Route as AuthenticatedChannelsIndexRouteImport } from './routes/_authenticated/channels/index'
import { Route as AuthenticatedApplicationIndexRouteImport } from './routes/_authenticated/application/index'
import { Route as AuthenticatedAiStaffIndexRouteImport } from './routes/_authenticated/ai-staff/index'
import { Route as AuthenticatedActivityIndexRouteImport } from './routes/_authenticated/activity/index'
import { Route as AuthenticatedWikiWikiSlugRouteImport } from './routes/_authenticated/wiki/$wikiSlug'
import { Route as AuthenticatedTasksNewTaskRouteImport } from './routes/_authenticated/tasks/new-task'
import { Route as AuthenticatedTasksNewConversationRouteImport } from './routes/_authenticated/tasks/new-conversation'
import { Route as AuthenticatedTasksTaskIdRouteImport } from './routes/_authenticated/tasks/$taskId'
import { Route as AuthenticatedSkillsSkillIdRouteImport } from './routes/_authenticated/skills/$skillId'
import { Route as AuthenticatedRoutinesRoutineIdRouteImport } from './routes/_authenticated/routines/$routineId'
import { Route as AuthenticatedMoreWorkspaceSettingsRouteImport } from './routes/_authenticated/more/workspace-settings'
import { Route as AuthenticatedMoreMembersRouteImport } from './routes/_authenticated/more/members'
import { Route as AuthenticatedMessagesChannelIdRouteImport } from './routes/_authenticated/messages/$channelId'
import { Route as AuthenticatedChannelsChannelIdRouteImport } from './routes/_authenticated/channels/$channelId'
import { Route as AuthenticatedApplicationAppIdRouteImport } from './routes/_authenticated/application/$appId'
import { Route as AuthenticatedAiStaffStaffIdRouteImport } from './routes/_authenticated/ai-staff/$staffId'
import { Route as AuthenticatedRoutinesRoutineIdIndexRouteImport } from './routes/_authenticated/routines/$routineId.index'
import { Route as AuthenticatedAiStaffStaffIdIndexRouteImport } from './routes/_authenticated/ai-staff/$staffId.index'
import { Route as AuthenticatedWikiWikiSlugSplatRouteImport } from './routes/_authenticated/wiki/$wikiSlug.$'
import { Route as AuthenticatedActivityChannelChannelIdRouteImport } from './routes/_authenticated/activity/channel.$channelId'
import { Route as AuthenticatedWikiWikiSlugReviewRouteImport } from './routes/_authenticated/wiki/$wikiSlug.-.review'
import { Route as AuthenticatedRoutinesRoutineIdRunsExecutionIdRouteImport } from './routes/_authenticated/routines/$routineId.runs.$executionId'
import { Route as AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRouteImport } from './routes/_authenticated/ai-staff/$staffId.workspace.$workspaceName'
import { Route as AuthenticatedWikiWikiSlugReviewProposalIdRouteImport } from './routes/_authenticated/wiki/$wikiSlug.-.review.$proposalId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailChangeRoute = ConfirmEmailChangeRouteImport.update({
  id: '/confirm-email-change',
  path: '/confirm-email-change',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: '/invite/$code',
  path: '/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSubscriptionRoute =
  AuthenticatedSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchRoute = AuthenticatedSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDevicesRoute = AuthenticatedDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWikiIndexRoute = AuthenticatedWikiIndexRouteImport.update({
  id: '/wiki/',
  path: '/wiki/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSkillsIndexRoute =
  AuthenticatedSkillsIndexRouteImport.update({
    id: '/skills/',
    path: '/skills/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutinesIndexRoute =
  AuthenticatedRoutinesIndexRouteImport.update({
    id: '/routines/',
    path: '/routines/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedResourcesIndexRoute =
  AuthenticatedResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMoreIndexRoute = AuthenticatedMoreIndexRouteImport.update({
  id: '/more/',
  path: '/more/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMessagesIndexRoute =
  AuthenticatedMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesIndexRoute = AuthenticatedFilesIndexRouteImport.update({
  id: '/files/',
  path: '/files/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChannelsIndexRoute =
  AuthenticatedChannelsIndexRouteImport.update({
    id: '/channels/',
    path: '/channels/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationIndexRoute =
  AuthenticatedApplicationIndexRouteImport.update({
    id: '/application/',
    path: '/application/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiStaffIndexRoute =
  AuthenticatedAiStaffIndexRouteImport.update({
    id: '/ai-staff/',
    path: '/ai-staff/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivityIndexRoute =
  AuthenticatedActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWikiWikiSlugRoute =
  AuthenticatedWikiWikiSlugRouteImport.update({
    id: '/wiki/$wikiSlug',
    path: '/wiki/$wikiSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewTaskRoute =
  AuthenticatedTasksNewTaskRouteImport.update({
    id: '/tasks/new-task',
    path: '/tasks/new-task',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksNewConversationRoute =
  AuthenticatedTasksNewConversationRouteImport.update({
    id: '/tasks/new-conversation',
    path: '/tasks/new-conversation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdRoute =
  AuthenticatedTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSkillsSkillIdRoute =
  AuthenticatedSkillsSkillIdRouteImport.update({
    id: '/skills/$skillId',
    path: '/skills/$skillId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutinesRoutineIdRoute =
  AuthenticatedRoutinesRoutineIdRouteImport.update({
    id: '/routines/$routineId',
    path: '/routines/$routineId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMoreWorkspaceSettingsRoute =
  AuthenticatedMoreWorkspaceSettingsRouteImport.update({
    id: '/more/workspace-settings',
    path: '/more/workspace-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMoreMembersRoute =
  AuthenticatedMoreMembersRouteImport.update({
    id: '/more/members',
    path: '/more/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMessagesChannelIdRoute =
  AuthenticatedMessagesChannelIdRouteImport.update({
    id: '/messages/$channelId',
    path: '/messages/$channelId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChannelsChannelIdRoute =
  AuthenticatedChannelsChannelIdRouteImport.update({
    id: '/channels/$channelId',
    path: '/channels/$channelId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApplicationAppIdRoute =
  AuthenticatedApplicationAppIdRouteImport.update({
    id: '/application/$appId',
    path: '/application/$appId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiStaffStaffIdRoute =
  AuthenticatedAiStaffStaffIdRouteImport.update({
    id: '/ai-staff/$staffId',
    path: '/ai-staff/$staffId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRoutinesRoutineIdIndexRoute =
  AuthenticatedRoutinesRoutineIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedRoutinesRoutineIdRoute,
  } as any)
const AuthenticatedAiStaffStaffIdIndexRoute =
  AuthenticatedAiStaffStaffIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAiStaffStaffIdRoute,
  } as any)
const AuthenticatedWikiWikiSlugSplatRoute =
  AuthenticatedWikiWikiSlugSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedWikiWikiSlugRoute,
  } as any)
const AuthenticatedActivityChannelChannelIdRoute =
  AuthenticatedActivityChannelChannelIdRouteImport.update({
    id: '/activity/channel/$channelId',
    path: '/activity/channel/$channelId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWikiWikiSlugReviewRoute =
  AuthenticatedWikiWikiSlugReviewRouteImport.update({
    id: '/-/review',
    path: '/-/review',
    getParentRoute: () => AuthenticatedWikiWikiSlugRoute,
  } as any)
const AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute =
  AuthenticatedRoutinesRoutineIdRunsExecutionIdRouteImport.update({
    id: '/runs/$executionId',
    path: '/runs/$executionId',
    getParentRoute: () => AuthenticatedRoutinesRoutineIdRoute,
  } as any)
const AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute =
  AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRouteImport.update({
    id: '/workspace/$workspaceName',
    path: '/workspace/$workspaceName',
    getParentRoute: () => AuthenticatedAiStaffStaffIdRoute,
  } as any)
const AuthenticatedWikiWikiSlugReviewProposalIdRoute =
  AuthenticatedWikiWikiSlugReviewProposalIdRouteImport.update({
    id: '/$proposalId',
    path: '/$proposalId',
    getParentRoute: () => AuthenticatedWikiWikiSlugReviewRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/devices': typeof AuthenticatedDevicesRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/search': typeof AuthenticatedSearchRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/invite/$code': typeof InviteCodeRoute
  '/': typeof AuthenticatedIndexRoute
  '/ai-staff/$staffId': typeof AuthenticatedAiStaffStaffIdRouteWithChildren
  '/application/$appId': typeof AuthenticatedApplicationAppIdRoute
  '/channels/$channelId': typeof AuthenticatedChannelsChannelIdRoute
  '/messages/$channelId': typeof AuthenticatedMessagesChannelIdRoute
  '/more/members': typeof AuthenticatedMoreMembersRoute
  '/more/workspace-settings': typeof AuthenticatedMoreWorkspaceSettingsRoute
  '/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdRouteWithChildren
  '/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/tasks/new-conversation': typeof AuthenticatedTasksNewConversationRoute
  '/tasks/new-task': typeof AuthenticatedTasksNewTaskRoute
  '/wiki/$wikiSlug': typeof AuthenticatedWikiWikiSlugRouteWithChildren
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/ai-staff': typeof AuthenticatedAiStaffIndexRoute
  '/application': typeof AuthenticatedApplicationIndexRoute
  '/channels': typeof AuthenticatedChannelsIndexRoute
  '/files': typeof AuthenticatedFilesIndexRoute
  '/messages': typeof AuthenticatedMessagesIndexRoute
  '/more': typeof AuthenticatedMoreIndexRoute
  '/resources': typeof AuthenticatedResourcesIndexRoute
  '/routines': typeof AuthenticatedRoutinesIndexRoute
  '/skills': typeof AuthenticatedSkillsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/wiki': typeof AuthenticatedWikiIndexRoute
  '/activity/channel/$channelId': typeof AuthenticatedActivityChannelChannelIdRoute
  '/wiki/$wikiSlug/$': typeof AuthenticatedWikiWikiSlugSplatRoute
  '/ai-staff/$staffId/': typeof AuthenticatedAiStaffStaffIdIndexRoute
  '/routines/$routineId/': typeof AuthenticatedRoutinesRoutineIdIndexRoute
  '/ai-staff/$staffId/workspace/$workspaceName': typeof AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute
  '/routines/$routineId/runs/$executionId': typeof AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute
  '/wiki/$wikiSlug/-/review': typeof AuthenticatedWikiWikiSlugReviewRouteWithChildren
  '/wiki/$wikiSlug/-/review/$proposalId': typeof AuthenticatedWikiWikiSlugReviewProposalIdRoute
}
export interface FileRoutesByTo {
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/devices': typeof AuthenticatedDevicesRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/search': typeof AuthenticatedSearchRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/invite/$code': typeof InviteCodeRoute
  '/': typeof AuthenticatedIndexRoute
  '/application/$appId': typeof AuthenticatedApplicationAppIdRoute
  '/channels/$channelId': typeof AuthenticatedChannelsChannelIdRoute
  '/messages/$channelId': typeof AuthenticatedMessagesChannelIdRoute
  '/more/members': typeof AuthenticatedMoreMembersRoute
  '/more/workspace-settings': typeof AuthenticatedMoreWorkspaceSettingsRoute
  '/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/tasks/new-conversation': typeof AuthenticatedTasksNewConversationRoute
  '/tasks/new-task': typeof AuthenticatedTasksNewTaskRoute
  '/wiki/$wikiSlug': typeof AuthenticatedWikiWikiSlugRouteWithChildren
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/ai-staff': typeof AuthenticatedAiStaffIndexRoute
  '/application': typeof AuthenticatedApplicationIndexRoute
  '/channels': typeof AuthenticatedChannelsIndexRoute
  '/files': typeof AuthenticatedFilesIndexRoute
  '/messages': typeof AuthenticatedMessagesIndexRoute
  '/more': typeof AuthenticatedMoreIndexRoute
  '/resources': typeof AuthenticatedResourcesIndexRoute
  '/routines': typeof AuthenticatedRoutinesIndexRoute
  '/skills': typeof AuthenticatedSkillsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/wiki': typeof AuthenticatedWikiIndexRoute
  '/activity/channel/$channelId': typeof AuthenticatedActivityChannelChannelIdRoute
  '/wiki/$wikiSlug/$': typeof AuthenticatedWikiWikiSlugSplatRoute
  '/ai-staff/$staffId': typeof AuthenticatedAiStaffStaffIdIndexRoute
  '/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdIndexRoute
  '/ai-staff/$staffId/workspace/$workspaceName': typeof AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute
  '/routines/$routineId/runs/$executionId': typeof AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute
  '/wiki/$wikiSlug/-/review': typeof AuthenticatedWikiWikiSlugReviewRouteWithChildren
  '/wiki/$wikiSlug/-/review/$proposalId': typeof AuthenticatedWikiWikiSlugReviewProposalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/confirm-email-change': typeof ConfirmEmailChangeRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/devices': typeof AuthenticatedDevicesRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/subscription': typeof AuthenticatedSubscriptionRoute
  '/invite/$code': typeof InviteCodeRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/ai-staff/$staffId': typeof AuthenticatedAiStaffStaffIdRouteWithChildren
  '/_authenticated/application/$appId': typeof AuthenticatedApplicationAppIdRoute
  '/_authenticated/channels/$channelId': typeof AuthenticatedChannelsChannelIdRoute
  '/_authenticated/messages/$channelId': typeof AuthenticatedMessagesChannelIdRoute
  '/_authenticated/more/members': typeof AuthenticatedMoreMembersRoute
  '/_authenticated/more/workspace-settings': typeof AuthenticatedMoreWorkspaceSettingsRoute
  '/_authenticated/routines/$routineId': typeof AuthenticatedRoutinesRoutineIdRouteWithChildren
  '/_authenticated/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/_authenticated/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
  '/_authenticated/tasks/new-conversation': typeof AuthenticatedTasksNewConversationRoute
  '/_authenticated/tasks/new-task': typeof AuthenticatedTasksNewTaskRoute
  '/_authenticated/wiki/$wikiSlug': typeof AuthenticatedWikiWikiSlugRouteWithChildren
  '/_authenticated/activity/': typeof AuthenticatedActivityIndexRoute
  '/_authenticated/ai-staff/': typeof AuthenticatedAiStaffIndexRoute
  '/_authenticated/application/': typeof AuthenticatedApplicationIndexRoute
  '/_authenticated/channels/': typeof AuthenticatedChannelsIndexRoute
  '/_authenticated/files/': typeof AuthenticatedFilesIndexRoute
  '/_authenticated/messages/': typeof AuthenticatedMessagesIndexRoute
  '/_authenticated/more/': typeof AuthenticatedMoreIndexRoute
  '/_authenticated/resources/': typeof AuthenticatedResourcesIndexRoute
  '/_authenticated/routines/': typeof AuthenticatedRoutinesIndexRoute
  '/_authenticated/skills/': typeof AuthenticatedSkillsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/wiki/': typeof AuthenticatedWikiIndexRoute
  '/_authenticated/activity/channel/$channelId': typeof AuthenticatedActivityChannelChannelIdRoute
  '/_authenticated/wiki/$wikiSlug/$': typeof AuthenticatedWikiWikiSlugSplatRoute
  '/_authenticated/ai-staff/$staffId/': typeof AuthenticatedAiStaffStaffIdIndexRoute
  '/_authenticated/routines/$routineId/': typeof AuthenticatedRoutinesRoutineIdIndexRoute
  '/_authenticated/ai-staff/$staffId/workspace/$workspaceName': typeof AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute
  '/_authenticated/routines/$routineId/runs/$executionId': typeof AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute
  '/_authenticated/wiki/$wikiSlug/-/review': typeof AuthenticatedWikiWikiSlugReviewRouteWithChildren
  '/_authenticated/wiki/$wikiSlug/-/review/$proposalId': typeof AuthenticatedWikiWikiSlugReviewProposalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/confirm-email-change'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms-of-service'
    | '/verify-email'
    | '/devices'
    | '/onboarding'
    | '/profile'
    | '/search'
    | '/subscription'
    | '/invite/$code'
    | '/'
    | '/ai-staff/$staffId'
    | '/application/$appId'
    | '/channels/$channelId'
    | '/messages/$channelId'
    | '/more/members'
    | '/more/workspace-settings'
    | '/routines/$routineId'
    | '/skills/$skillId'
    | '/tasks/$taskId'
    | '/tasks/new-conversation'
    | '/tasks/new-task'
    | '/wiki/$wikiSlug'
    | '/activity'
    | '/ai-staff'
    | '/application'
    | '/channels'
    | '/files'
    | '/messages'
    | '/more'
    | '/resources'
    | '/routines'
    | '/skills'
    | '/tasks'
    | '/wiki'
    | '/activity/channel/$channelId'
    | '/wiki/$wikiSlug/$'
    | '/ai-staff/$staffId/'
    | '/routines/$routineId/'
    | '/ai-staff/$staffId/workspace/$workspaceName'
    | '/routines/$routineId/runs/$executionId'
    | '/wiki/$wikiSlug/-/review'
    | '/wiki/$wikiSlug/-/review/$proposalId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/confirm-email-change'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms-of-service'
    | '/verify-email'
    | '/devices'
    | '/onboarding'
    | '/profile'
    | '/search'
    | '/subscription'
    | '/invite/$code'
    | '/'
    | '/application/$appId'
    | '/channels/$channelId'
    | '/messages/$channelId'
    | '/more/members'
    | '/more/workspace-settings'
    | '/skills/$skillId'
    | '/tasks/$taskId'
    | '/tasks/new-conversation'
    | '/tasks/new-task'
    | '/wiki/$wikiSlug'
    | '/activity'
    | '/ai-staff'
    | '/application'
    | '/channels'
    | '/files'
    | '/messages'
    | '/more'
    | '/resources'
    | '/routines'
    | '/skills'
    | '/tasks'
    | '/wiki'
    | '/activity/channel/$channelId'
    | '/wiki/$wikiSlug/$'
    | '/ai-staff/$staffId'
    | '/routines/$routineId'
    | '/ai-staff/$staffId/workspace/$workspaceName'
    | '/routines/$routineId/runs/$executionId'
    | '/wiki/$wikiSlug/-/review'
    | '/wiki/$wikiSlug/-/review/$proposalId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/confirm-email-change'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms-of-service'
    | '/verify-email'
    | '/_authenticated/devices'
    | '/_authenticated/onboarding'
    | '/_authenticated/profile'
    | '/_authenticated/search'
    | '/_authenticated/subscription'
    | '/invite/$code'
    | '/_authenticated/'
    | '/_authenticated/ai-staff/$staffId'
    | '/_authenticated/application/$appId'
    | '/_authenticated/channels/$channelId'
    | '/_authenticated/messages/$channelId'
    | '/_authenticated/more/members'
    | '/_authenticated/more/workspace-settings'
    | '/_authenticated/routines/$routineId'
    | '/_authenticated/skills/$skillId'
    | '/_authenticated/tasks/$taskId'
    | '/_authenticated/tasks/new-conversation'
    | '/_authenticated/tasks/new-task'
    | '/_authenticated/wiki/$wikiSlug'
    | '/_authenticated/activity/'
    | '/_authenticated/ai-staff/'
    | '/_authenticated/application/'
    | '/_authenticated/channels/'
    | '/_authenticated/files/'
    | '/_authenticated/messages/'
    | '/_authenticated/more/'
    | '/_authenticated/resources/'
    | '/_authenticated/routines/'
    | '/_authenticated/skills/'
    | '/_authenticated/tasks/'
    | '/_authenticated/wiki/'
    | '/_authenticated/activity/channel/$channelId'
    | '/_authenticated/wiki/$wikiSlug/$'
    | '/_authenticated/ai-staff/$staffId/'
    | '/_authenticated/routines/$routineId/'
    | '/_authenticated/ai-staff/$staffId/workspace/$workspaceName'
    | '/_authenticated/routines/$routineId/runs/$executionId'
    | '/_authenticated/wiki/$wikiSlug/-/review'
    | '/_authenticated/wiki/$wikiSlug/-/review/$proposalId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ConfirmEmailChangeRoute: typeof ConfirmEmailChangeRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  InviteCodeRoute: typeof InviteCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email-change': {
      id: '/confirm-email-change'
      path: '/confirm-email-change'
      fullPath: '/confirm-email-change'
      preLoaderRoute: typeof ConfirmEmailChangeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/invite/$code': {
      id: '/invite/$code'
      path: '/invite/$code'
      fullPath: '/invite/$code'
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/subscription': {
      id: '/_authenticated/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/devices': {
      id: '/_authenticated/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof AuthenticatedDevicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wiki/': {
      id: '/_authenticated/wiki/'
      path: '/wiki'
      fullPath: '/wiki'
      preLoaderRoute: typeof AuthenticatedWikiIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills/': {
      id: '/_authenticated/skills/'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routines/': {
      id: '/_authenticated/routines/'
      path: '/routines'
      fullPath: '/routines'
      preLoaderRoute: typeof AuthenticatedRoutinesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/resources/': {
      id: '/_authenticated/resources/'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AuthenticatedResourcesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/more/': {
      id: '/_authenticated/more/'
      path: '/more'
      fullPath: '/more'
      preLoaderRoute: typeof AuthenticatedMoreIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/': {
      id: '/_authenticated/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/': {
      id: '/_authenticated/files/'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/channels/': {
      id: '/_authenticated/channels/'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof AuthenticatedChannelsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/application/': {
      id: '/_authenticated/application/'
      path: '/application'
      fullPath: '/application'
      preLoaderRoute: typeof AuthenticatedApplicationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-staff/': {
      id: '/_authenticated/ai-staff/'
      path: '/ai-staff'
      fullPath: '/ai-staff'
      preLoaderRoute: typeof AuthenticatedAiStaffIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/': {
      id: '/_authenticated/activity/'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wiki/$wikiSlug': {
      id: '/_authenticated/wiki/$wikiSlug'
      path: '/wiki/$wikiSlug'
      fullPath: '/wiki/$wikiSlug'
      preLoaderRoute: typeof AuthenticatedWikiWikiSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new-task': {
      id: '/_authenticated/tasks/new-task'
      path: '/tasks/new-task'
      fullPath: '/tasks/new-task'
      preLoaderRoute: typeof AuthenticatedTasksNewTaskRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/new-conversation': {
      id: '/_authenticated/tasks/new-conversation'
      path: '/tasks/new-conversation'
      fullPath: '/tasks/new-conversation'
      preLoaderRoute: typeof AuthenticatedTasksNewConversationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId': {
      id: '/_authenticated/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills/$skillId': {
      id: '/_authenticated/skills/$skillId'
      path: '/skills/$skillId'
      fullPath: '/skills/$skillId'
      preLoaderRoute: typeof AuthenticatedSkillsSkillIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routines/$routineId': {
      id: '/_authenticated/routines/$routineId'
      path: '/routines/$routineId'
      fullPath: '/routines/$routineId'
      preLoaderRoute: typeof AuthenticatedRoutinesRoutineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/more/workspace-settings': {
      id: '/_authenticated/more/workspace-settings'
      path: '/more/workspace-settings'
      fullPath: '/more/workspace-settings'
      preLoaderRoute: typeof AuthenticatedMoreWorkspaceSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/more/members': {
      id: '/_authenticated/more/members'
      path: '/more/members'
      fullPath: '/more/members'
      preLoaderRoute: typeof AuthenticatedMoreMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/$channelId': {
      id: '/_authenticated/messages/$channelId'
      path: '/messages/$channelId'
      fullPath: '/messages/$channelId'
      preLoaderRoute: typeof AuthenticatedMessagesChannelIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/channels/$channelId': {
      id: '/_authenticated/channels/$channelId'
      path: '/channels/$channelId'
      fullPath: '/channels/$channelId'
      preLoaderRoute: typeof AuthenticatedChannelsChannelIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/application/$appId': {
      id: '/_authenticated/application/$appId'
      path: '/application/$appId'
      fullPath: '/application/$appId'
      preLoaderRoute: typeof AuthenticatedApplicationAppIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-staff/$staffId': {
      id: '/_authenticated/ai-staff/$staffId'
      path: '/ai-staff/$staffId'
      fullPath: '/ai-staff/$staffId'
      preLoaderRoute: typeof AuthenticatedAiStaffStaffIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/routines/$routineId/': {
      id: '/_authenticated/routines/$routineId/'
      path: '/'
      fullPath: '/routines/$routineId/'
      preLoaderRoute: typeof AuthenticatedRoutinesRoutineIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoutinesRoutineIdRoute
    }
    '/_authenticated/ai-staff/$staffId/': {
      id: '/_authenticated/ai-staff/$staffId/'
      path: '/'
      fullPath: '/ai-staff/$staffId/'
      preLoaderRoute: typeof AuthenticatedAiStaffStaffIdIndexRouteImport
      parentRoute: typeof AuthenticatedAiStaffStaffIdRoute
    }
    '/_authenticated/wiki/$wikiSlug/$': {
      id: '/_authenticated/wiki/$wikiSlug/$'
      path: '/$'
      fullPath: '/wiki/$wikiSlug/$'
      preLoaderRoute: typeof AuthenticatedWikiWikiSlugSplatRouteImport
      parentRoute: typeof AuthenticatedWikiWikiSlugRoute
    }
    '/_authenticated/activity/channel/$channelId': {
      id: '/_authenticated/activity/channel/$channelId'
      path: '/activity/channel/$channelId'
      fullPath: '/activity/channel/$channelId'
      preLoaderRoute: typeof AuthenticatedActivityChannelChannelIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/wiki/$wikiSlug/-/review': {
      id: '/_authenticated/wiki/$wikiSlug/-/review'
      path: '/-/review'
      fullPath: '/wiki/$wikiSlug/-/review'
      preLoaderRoute: typeof AuthenticatedWikiWikiSlugReviewRouteImport
      parentRoute: typeof AuthenticatedWikiWikiSlugRoute
    }
    '/_authenticated/routines/$routineId/runs/$executionId': {
      id: '/_authenticated/routines/$routineId/runs/$executionId'
      path: '/runs/$executionId'
      fullPath: '/routines/$routineId/runs/$executionId'
      preLoaderRoute: typeof AuthenticatedRoutinesRoutineIdRunsExecutionIdRouteImport
      parentRoute: typeof AuthenticatedRoutinesRoutineIdRoute
    }
    '/_authenticated/ai-staff/$staffId/workspace/$workspaceName': {
      id: '/_authenticated/ai-staff/$staffId/workspace/$workspaceName'
      path: '/workspace/$workspaceName'
      fullPath: '/ai-staff/$staffId/workspace/$workspaceName'
      preLoaderRoute: typeof AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRouteImport
      parentRoute: typeof AuthenticatedAiStaffStaffIdRoute
    }
    '/_authenticated/wiki/$wikiSlug/-/review/$proposalId': {
      id: '/_authenticated/wiki/$wikiSlug/-/review/$proposalId'
      path: '/$proposalId'
      fullPath: '/wiki/$wikiSlug/-/review/$proposalId'
      preLoaderRoute: typeof AuthenticatedWikiWikiSlugReviewProposalIdRouteImport
      parentRoute: typeof AuthenticatedWikiWikiSlugReviewRoute
    }
  }
}

interface AuthenticatedAiStaffStaffIdRouteChildren {
  AuthenticatedAiStaffStaffIdIndexRoute: typeof AuthenticatedAiStaffStaffIdIndexRoute
  AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute: typeof AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute
}

const AuthenticatedAiStaffStaffIdRouteChildren: AuthenticatedAiStaffStaffIdRouteChildren =
  {
    AuthenticatedAiStaffStaffIdIndexRoute:
      AuthenticatedAiStaffStaffIdIndexRoute,
    AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute:
      AuthenticatedAiStaffStaffIdWorkspaceWorkspaceNameRoute,
  }

const AuthenticatedAiStaffStaffIdRouteWithChildren =
  AuthenticatedAiStaffStaffIdRoute._addFileChildren(
    AuthenticatedAiStaffStaffIdRouteChildren,
  )

interface AuthenticatedRoutinesRoutineIdRouteChildren {
  AuthenticatedRoutinesRoutineIdIndexRoute: typeof AuthenticatedRoutinesRoutineIdIndexRoute
  AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute: typeof AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute
}

const AuthenticatedRoutinesRoutineIdRouteChildren: AuthenticatedRoutinesRoutineIdRouteChildren =
  {
    AuthenticatedRoutinesRoutineIdIndexRoute:
      AuthenticatedRoutinesRoutineIdIndexRoute,
    AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute:
      AuthenticatedRoutinesRoutineIdRunsExecutionIdRoute,
  }

const AuthenticatedRoutinesRoutineIdRouteWithChildren =
  AuthenticatedRoutinesRoutineIdRoute._addFileChildren(
    AuthenticatedRoutinesRoutineIdRouteChildren,
  )

interface AuthenticatedWikiWikiSlugReviewRouteChildren {
  AuthenticatedWikiWikiSlugReviewProposalIdRoute: typeof AuthenticatedWikiWikiSlugReviewProposalIdRoute
}

const AuthenticatedWikiWikiSlugReviewRouteChildren: AuthenticatedWikiWikiSlugReviewRouteChildren =
  {
    AuthenticatedWikiWikiSlugReviewProposalIdRoute:
      AuthenticatedWikiWikiSlugReviewProposalIdRoute,
  }

const AuthenticatedWikiWikiSlugReviewRouteWithChildren =
  AuthenticatedWikiWikiSlugReviewRoute._addFileChildren(
    AuthenticatedWikiWikiSlugReviewRouteChildren,
  )

interface AuthenticatedWikiWikiSlugRouteChildren {
  AuthenticatedWikiWikiSlugSplatRoute: typeof AuthenticatedWikiWikiSlugSplatRoute
  AuthenticatedWikiWikiSlugReviewRoute: typeof AuthenticatedWikiWikiSlugReviewRouteWithChildren
}

const AuthenticatedWikiWikiSlugRouteChildren: AuthenticatedWikiWikiSlugRouteChildren =
  {
    AuthenticatedWikiWikiSlugSplatRoute: AuthenticatedWikiWikiSlugSplatRoute,
    AuthenticatedWikiWikiSlugReviewRoute:
      AuthenticatedWikiWikiSlugReviewRouteWithChildren,
  }

const AuthenticatedWikiWikiSlugRouteWithChildren =
  AuthenticatedWikiWikiSlugRoute._addFileChildren(
    AuthenticatedWikiWikiSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDevicesRoute: typeof AuthenticatedDevicesRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedSubscriptionRoute: typeof AuthenticatedSubscriptionRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAiStaffStaffIdRoute: typeof AuthenticatedAiStaffStaffIdRouteWithChildren
  AuthenticatedApplicationAppIdRoute: typeof AuthenticatedApplicationAppIdRoute
  AuthenticatedChannelsChannelIdRoute: typeof AuthenticatedChannelsChannelIdRoute
  AuthenticatedMessagesChannelIdRoute: typeof AuthenticatedMessagesChannelIdRoute
  AuthenticatedMoreMembersRoute: typeof AuthenticatedMoreMembersRoute
  AuthenticatedMoreWorkspaceSettingsRoute: typeof AuthenticatedMoreWorkspaceSettingsRoute
  AuthenticatedRoutinesRoutineIdRoute: typeof AuthenticatedRoutinesRoutineIdRouteWithChildren
  AuthenticatedSkillsSkillIdRoute: typeof AuthenticatedSkillsSkillIdRoute
  AuthenticatedTasksTaskIdRoute: typeof AuthenticatedTasksTaskIdRoute
  AuthenticatedTasksNewConversationRoute: typeof AuthenticatedTasksNewConversationRoute
  AuthenticatedTasksNewTaskRoute: typeof AuthenticatedTasksNewTaskRoute
  AuthenticatedWikiWikiSlugRoute: typeof AuthenticatedWikiWikiSlugRouteWithChildren
  AuthenticatedActivityIndexRoute: typeof AuthenticatedActivityIndexRoute
  AuthenticatedAiStaffIndexRoute: typeof AuthenticatedAiStaffIndexRoute
  AuthenticatedApplicationIndexRoute: typeof AuthenticatedApplicationIndexRoute
  AuthenticatedChannelsIndexRoute: typeof AuthenticatedChannelsIndexRoute
  AuthenticatedFilesIndexRoute: typeof AuthenticatedFilesIndexRoute
  AuthenticatedMessagesIndexRoute: typeof AuthenticatedMessagesIndexRoute
  AuthenticatedMoreIndexRoute: typeof AuthenticatedMoreIndexRoute
  AuthenticatedResourcesIndexRoute: typeof AuthenticatedResourcesIndexRoute
  AuthenticatedRoutinesIndexRoute: typeof AuthenticatedRoutinesIndexRoute
  AuthenticatedSkillsIndexRoute: typeof AuthenticatedSkillsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedWikiIndexRoute: typeof AuthenticatedWikiIndexRoute
  AuthenticatedActivityChannelChannelIdRoute: typeof AuthenticatedActivityChannelChannelIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDevicesRoute: AuthenticatedDevicesRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedSubscriptionRoute: AuthenticatedSubscriptionRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAiStaffStaffIdRoute:
    AuthenticatedAiStaffStaffIdRouteWithChildren,
  AuthenticatedApplicationAppIdRoute: AuthenticatedApplicationAppIdRoute,
  AuthenticatedChannelsChannelIdRoute: AuthenticatedChannelsChannelIdRoute,
  AuthenticatedMessagesChannelIdRoute: AuthenticatedMessagesChannelIdRoute,
  AuthenticatedMoreMembersRoute: AuthenticatedMoreMembersRoute,
  AuthenticatedMoreWorkspaceSettingsRoute:
    AuthenticatedMoreWorkspaceSettingsRoute,
  AuthenticatedRoutinesRoutineIdRoute:
    AuthenticatedRoutinesRoutineIdRouteWithChildren,
  AuthenticatedSkillsSkillIdRoute: AuthenticatedSkillsSkillIdRoute,
  AuthenticatedTasksTaskIdRoute: AuthenticatedTasksTaskIdRoute,
  AuthenticatedTasksNewConversationRoute:
    AuthenticatedTasksNewConversationRoute,
  AuthenticatedTasksNewTaskRoute: AuthenticatedTasksNewTaskRoute,
  AuthenticatedWikiWikiSlugRoute: AuthenticatedWikiWikiSlugRouteWithChildren,
  AuthenticatedActivityIndexRoute: AuthenticatedActivityIndexRoute,
  AuthenticatedAiStaffIndexRoute: AuthenticatedAiStaffIndexRoute,
  AuthenticatedApplicationIndexRoute: AuthenticatedApplicationIndexRoute,
  AuthenticatedChannelsIndexRoute: AuthenticatedChannelsIndexRoute,
  AuthenticatedFilesIndexRoute: AuthenticatedFilesIndexRoute,
  AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute,
  AuthenticatedMoreIndexRoute: AuthenticatedMoreIndexRoute,
  AuthenticatedResourcesIndexRoute: AuthenticatedResourcesIndexRoute,
  AuthenticatedRoutinesIndexRoute: AuthenticatedRoutinesIndexRoute,
  AuthenticatedSkillsIndexRoute: AuthenticatedSkillsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedWikiIndexRoute: AuthenticatedWikiIndexRoute,
  AuthenticatedActivityChannelChannelIdRoute:
    AuthenticatedActivityChannelChannelIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ConfirmEmailChangeRoute: ConfirmEmailChangeRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  InviteCodeRoute: InviteCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
